import { render, staticRenderFns } from "./submitError.vue?vue&type=template&id=97b334b2&scoped=true"
import script from "./submitError.vue?vue&type=script&lang=js"
export * from "./submitError.vue?vue&type=script&lang=js"
import style0 from "./submitError.vue?vue&type=style&index=0&id=97b334b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b334b2",
  null
  
)

export default component.exports